import videojs from "video.js";

import commentIcon from "./icon/commentIcon.svg";

import type Player from "video.js/dist/types/player";

/**
 * HACK: theoplayerの読み込みが完了する前にこのモジュールがインポートされると、
 * getVideoJsComponent内でwindow.THEOplayerがundefinedとなりエラーになるため、
 * 関数としてエクスポートし、必要なときに呼び出す形にする。
 * 本当はnpm管理のtheoplayerパッケージを使いたいが、検証が不十分なため現状はこの方法で対応。
 */
export const getFullscreenCommentIvsButton = () => {
  const Button = videojs.getComponent("Button");

  class FullscreenCommentButton extends Button {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    handleClick() {
      const target = document.getElementById("fullscreen-streaming-comment");
      if (target) {
        if (target.style.display === "none") {
          target.style.display = "flex";
        } else {
          target.style.display = "none";
        }
      }
    }

    createEl() {
      return videojs.dom.createEl("button", {
        className:
          "vjs-custom-fullscreen-comment-button vjs-custom-button vjs-control vjs-button",
        innerHTML: `<img src="${commentIcon}" alt="Fullscreen Comment Button"/><span class="vjs-control-text">コメント表示切り替え</span>`,
        title: "Fullscreen comment button",
      });
    }
  }

  return FullscreenCommentButton;
};
